import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api/business'
  : 'http://localhost:3400/api/business';

const businessService = {
  login: async (credentials) => {
    try {
      const response = await axios.post(`${API_URL}/login`, credentials);
      if (response.data.token) {
        localStorage.setItem('businessToken', response.data.token);
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  verifyToken: async (token) => {
    try {
      const response = await axios.post(`${API_URL}/verify-token`, { token });
      return response.data.isValid;
    } catch (error) {
      return false;
    }
  },

  getDashboard: async () => {
    const token = localStorage.getItem('businessToken');
    const response = await axios.get(`${API_URL}/dashboard`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getPrizeStats: async () => {
    const token = localStorage.getItem('businessToken');
    const response = await axios.get(`${API_URL}/prizes`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('business_token');
  },

  getWinners: async () => {
    const token = localStorage.getItem('businessToken');
    const response = await axios.get(
      `${API_URL}/winners`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  },

  downloadWinners: async () => {
    try {
      const token = localStorage.getItem('businessToken');
      const response = await axios({
        url: `${API_URL}/winners/download`,
        method: 'GET',
        headers: { 
          Authorization: `Bearer ${token}` 
        },
        responseType: 'blob'
      });

      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'ganadores.csv';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  },

  getCampaign: async (adminUrl) => {
    const token = localStorage.getItem('businessToken');
    const response = await axios.get(
      `${API_URL}/campaign/${adminUrl}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  },

  getStats: async () => {
    try {
      const token = localStorage.getItem('businessToken');
      const response = await axios.get(`${API_URL}/stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      console.error('Error getting stats:', error);
      throw error;
    }
  },

  redeemPrize: async (participationId) => {
    const token = localStorage.getItem('businessToken');
    const response = await axios.post(
      `${API_URL}/winners/${participationId}/redeem`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  }
};

export default businessService; 